import React from 'react';
import './Slider.style.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Virtual,
  Keyboard,
  Mousewheel,
  Navigation,
  Pagination,
  Scrollbar,
  Parallax,
  FreeMode,
  Grid,
  Manipulation,
  Zoom,
  Controller,
  A11y,
  History,
  HashNavigation,
  Autoplay,
  EffectFade,
  EffectCube,
  EffectFlip,
  EffectCoverflow,
  EffectCards,
  EffectCreative,
  Thumbs,
} from 'swiper/modules';

// CSS
import 'swiper/css';
import 'swiper/css/virtual';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

const Slider = ({
  items = [],
  render = () => {},
  modules = [],
  itemStyle = {},
  ...props
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  const moduleList = {
    Virtual,
    Keyboard,
    Mousewheel,
    Navigation,
    Pagination,
    Scrollbar,
    Parallax,
    FreeMode,
    Grid,
    Manipulation,
    Zoom,
    Controller,
    A11y,
    History,
    HashNavigation,
    Autoplay,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    EffectCards,
    EffectCreative,
    Thumbs,
  };

  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <Swiper {...props} modules={modules.map((m) => moduleList[m])}>
      {items.map((_item, _index) => (
        <SwiperSlide key={`slide_${_index}`} style={{ ...itemStyle }}>
          {({ isActive, isNext, isPrev, isVisible }) =>
            render(_item, _index, { isActive, isNext, isPrev, isVisible })
          }
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Slider;
